import { render, staticRenderFns } from "./ConfigCategoryUnits.vue?vue&type=template&id=53994c47&"
import script from "./ConfigCategoryUnits.vue?vue&type=script&lang=js&"
export * from "./ConfigCategoryUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports